import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "The Art of the Root Canal",
    body:
      "A root canal, unhurried. Microscopic magnification, rotary NiTi files, and a rubber-dam field ensure the pulp is cleared and sealed with millimetric certainty — one visit, most cases.",
    tag: "Endodontics",
  },
  {
    num: "02",
    title: "Implants & Zirconia, Considered",
    body:
      "Titanium roots and monolithic zirconia crowns, planned digitally, placed conservatively. Restorations designed to disappear into the face — not announce themselves.",
    tag: "Prosthodontics",
  },
  {
    num: "03",
    title: "Aligners, Braces & Bite",
    body:
      "From ceramic brackets to clear aligners, we choose the least invasive path to a level bite and honest smile line. Every plan begins with a full facial analysis.",
    tag: "Orthodontics",
  },
  {
    num: "04",
    title: "Laminates & Aesthetic Dentistry",
    body:
      "0.3 mm porcelain laminates, shade-matched under natural light. We shape enamel like fabric — a slow, tactile discipline focused on what looks unretouched.",
    tag: "Cosmetic",
  },
];

export default function Manifesto() {
  return (
    <section
      id="philosophy"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 border-b border-bone"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-20 md:mb-32">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-ink" />
              <span className="eyebrow">A Manifesto</span>
              <span className="font-malayalam text-[13px] text-ink/60 leading-none">ദർശനം</span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-7">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
              className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
              data-testid="manifesto-heading"
              style={{ color: "#4A3520" }}
            >
              We treat the tooth,
              <br />
              <span className="italic" style={{ color: "#B8944E" }}>but consider the face</span> —
              <br />
              and the person behind it.
            </motion.h2>
          </div>
        </div>

        <div className="space-y-24 md:space-y-40">
          {chapters.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: 0.05, ease: [0.76, 0, 0.24, 1] }}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start"
              data-testid={`chapter-${c.num}`}
            >
              <div className="col-span-12 md:col-span-4 flex md:block items-baseline gap-6">
                <div className="font-serif italic text-[22vw] md:text-[10vw] leading-[0.85] text-ink/10 select-none">
                  {c.num}
                </div>
              </div>
              <div className="col-span-12 md:col-span-8 md:pl-10">
                <div className="eyebrow mb-6">{c.tag}</div>
                <h3 className="font-serif font-light text-ink text-3xl md:text-5xl leading-[1.02] tracking-tight max-w-[22ch]">
                  {c.title}
                </h3>
                <p className="mt-8 text-ink/70 text-base md:text-lg leading-relaxed max-w-[52ch] font-light">
                  {c.body}
                </p>
                <div className="mt-10 h-px w-24 bg-ink/40" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
